import { TypographyProps } from '@pogokid/mui'
import cx from 'classnames'
import styles from './Headline.module.css'
import { PropsWithChildren } from 'react'

interface HeadlineProps {
  className?: string
  component?: TypographyProps['component']
  size?: 'md' | 'lg' | 'xl'
}

export function Headline({
  children,
  className,
  size,
  component,
}: PropsWithChildren<HeadlineProps>) {
  const Component = component ?? 'h2'
  return (
    <Component
      className={cx(styles.Headline, className, {
        [styles.isSizeXl]: size === 'xl',
        [styles.isSizeMd]: size === 'md',
        [styles.isSizeLg]: !size || size === 'lg',
      })}
    >
      {children}
    </Component>
  )
}
